import React from 'react';
import _ from 'underscore';

import { RouterError } from '~src/bootstrap/routerHelpers/RouterError';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { MobileSecuritySettingsService } from '~src/settings/mobile-settings/MobileSecuritySettingsShared';
import { MobileServerSettingsCoordinator } from '~src/settings/mobile-settings/server-settings/MobileServerSettingsCoordinator';
import { IMobileSecuritySettings } from '~src/settings/mobile-settings/serverApi/types/IMobileSecuritySettings';
import { subspaceStyle } from '~src/settings/styles/CommonStyles';
import { ISiteSettingsForSiteAdmin } from '~src/settings/types/ISiteSettingsForSiteAdmin';
import { Sites } from '~src/siteManagement/services/resources/Sites';

interface MobileServerSettingsSubspaceOwnProps {
  readonly server: SessionManagementService;
  readonly isSessionMultiSite: boolean;
}

export interface MobileServerSettingsSubspaceState {
  readonly hasDataToRender: boolean;
  readonly hasError: boolean;
  readonly isSessionMultiSite: boolean;
  readonly siteSettingsForSiteAdmin: ISiteSettingsForSiteAdmin;
  readonly mobileSecuritySettings: IMobileSecuritySettings;
}
export class MobileServerSettingsSubspaceComponent extends React.PureComponent<MobileServerSettingsSubspaceOwnProps, MobileServerSettingsSubspaceState> {

  private unmounted: boolean = false;

  private initialState: MobileServerSettingsSubspaceState = {
    hasDataToRender: false,
    hasError: false,
    siteSettingsForSiteAdmin: undefined,
    isSessionMultiSite: undefined,
    mobileSecuritySettings: undefined,
  };

  public constructor(props: MobileServerSettingsSubspaceOwnProps) {
    super(props);
    this.state = {
      ...this.initialState,
      isSessionMultiSite: props.isSessionMultiSite
    };
  }

  public componentDidMount() {
    this.getData();
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate() {
    if (!_.isUndefined(this.state.siteSettingsForSiteAdmin)
      || (!_.isUndefined(this.state.mobileSecuritySettings) && (FeatureFlags.mobileSecuritySettingsEnabled))
    ) {
      this.updateState({hasDataToRender: true});
    }
  }

  public render() {
    if (!this.state.hasDataToRender) {
      return null;
    } else if (this.state.hasError) {
      return <RouterError errorType={'server-default'} urls={undefined}/>;
    }

    return (
      <div className={subspaceStyle}>
        <MobileServerSettingsCoordinator {...this.state}/>
      </div>
    );
  }

  private updateState<K extends keyof MobileServerSettingsSubspaceState>(newState: Pick<MobileServerSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }

  private getData = async () => {
    try {
      let serverSettings = this.state.siteSettingsForSiteAdmin;
      if (!this.state.isSessionMultiSite) {
        await this.props.server.getSessionInfoPromise();
        serverSettings = await Sites.instance.getCurrentSiteSettingsForSiteAdmin();
      }
      const mobileSecurityServerSettings = await MobileSecuritySettingsService.getMobileSecuritySettingsForServer();
      this.updateState({
        siteSettingsForSiteAdmin: serverSettings,
        mobileSecuritySettings: mobileSecurityServerSettings
      });
    } catch (e) {
      this.updateState({hasError: true});
    }
  };
}
